// extracted by mini-css-extract-plugin
export default {"wrapper":"LiveCameras_wrapper__lLmfQ","container":"LiveCameras_container__2FA27","footer":"LiveCameras_footer__ge7q4"};